import type { Story } from '@shared/api/types/story';
import { ACTION_TYPES, STATUS_TYPES } from '@shared/api/types/story';

export const magicstoreMdbFinancialsExclusive: Story = {
  id: 'magicstore-mdb-financials-exclusive',
  type: 'SOQUEST',
  status: STATUS_TYPES.ACTIVE,
  name: 'Magic Store mdb financials exclusive',
  index: 0,
  content: {
    type: ACTION_TYPES.SOQUEST,
    metadata: {
      title: 'Magic Store Web3 App Giveaway: Win 15,000 SHIB with MBD Financials Campaign',
      description:
        'Enter the web3 world at Magic Store by Magic Square. Join our MBD Financials campaign for a chance to win a 15,000 SHIB',
      keywords:
        'Web3, Crypto, Giveaway, Magic Store, Magic Square, MBD Financials Campaign, SHIB, Web3 App Store, Decentralized Apps, Crypto Rewards, Blockchain, DApps, Win Crypto, Digital Assets, Web3 Technology',
    },
    config: {
      key: 'f42bd88c0c380a2c5ed4e663e714b7926bac',
      scode: 'MagicSquare',
      ccode: 'hGFT24YNPJ',
    },
  },
};
